import React from "react";
import { Link } from "react-router-dom";
import data from "../data/biodata.json";
import PageShell from "../common/page_shell";
import Landing from "../landing/landing";
import { useTheme } from "../../theme/themeContext";

const HomePage = () => {
  const { preferences } = useTheme();
  const about = data?.details?.about_me || {};
  const services = data?.details?.services || [];
  const pages = (data?.pages || []).filter(
    (item) => item.key === "url" && item.url !== "/gallery"
  );

  if (preferences.templateId === "single") {
    return <Landing />;
  }

  return (
    <PageShell>
      <section className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Portfolio Home
          </p>
          <h1 className="max-w-3xl font-display text-4xl font-bold leading-tight text-skin-text md:text-6xl">
            {about.headline}
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-8 text-skin-muted md:text-lg">
            {about.short_description}
          </p>
          <div className="mt-8 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {pages.map((page) => (
              <Link
                key={page.title}
                to={page.url}
                className="rounded-[1.5rem] border border-white/15 bg-black/10 p-5 transition hover:-translate-y-1 hover:bg-white/10"
              >
                <div className="text-xs font-semibold uppercase tracking-[0.28em] text-skin-accentSoft">
                  Open Page
                </div>
                <div className="mt-3 font-display text-2xl font-semibold text-skin-text">
                  {page.title}
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-4 shadow-glass backdrop-blur-xl">
          <div className="relative overflow-hidden rounded-[1.75rem] bg-black/20">
            <img
              src={about.main_image}
              alt={about.name}
              className="h-full min-h-[380px] w-full object-cover"
            />
            <div className="absolute inset-x-4 bottom-4 rounded-[1.5rem] border border-white/20 bg-black/30 p-4 backdrop-blur-xl">
              <p className="text-sm uppercase tracking-[0.28em] text-skin-accentSoft">
                {about.title}
              </p>
              <h2 className="mt-2 font-display text-2xl font-semibold text-white">
                {about.name}
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {services.map((service) => (
          <article
            key={service.title}
            className="rounded-[1.75rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-skin-accentSoft">
              {service.kicker}
            </p>
            <h3 className="mt-3 font-display text-2xl font-semibold text-skin-text">
              {service.title}
            </h3>
            <p className="mt-3 text-sm leading-7 text-skin-muted">
              {service.description}
            </p>
          </article>
        ))}
      </section>
    </PageShell>
  );
};

export default HomePage;
